"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveClassifierDefaultData = void 0;
const compareUpdateHash_1 = require("./compareUpdateHash");
const saveClassifierPublicData_1 = require("./saveClassifierPublicData");
function saveClassifierDefaultData(context, entityName, classifier) {
    const storage = context.storage(entityName);
    const rows = storage.list({ filter: [{ column: 'defaultName', op: 'is-not-null' }] }).rows;
    const defaultDataCopy = Array.isArray(classifier.defaultData)
        ? [...classifier.defaultData]
        : typeof classifier.defaultData === 'function'
            ? [...classifier.defaultData(context)]
            : undefined;
    if (defaultDataCopy) {
        (0, compareUpdateHash_1.compareUpdateHash)(context, entityName, defaultDataCopy, () => {
            const timestampBeforeSave = Date.now();
            context.utils.executeInTransaction(() => {
                var _a;
                for (const row of rows) {
                    let defaultName = row.columns.defaultName;
                    for (const { from, to } of (_a = classifier.defaultNameChanges) !== null && _a !== void 0 ? _a : []) {
                        if (defaultName === from) {
                            defaultName = to;
                        }
                    }
                    const index = defaultDataCopy.findIndex((c) => c.name === defaultName);
                    if (index !== -1) {
                        const oldClassifier = storage.get(row.id).data;
                        const [defaultClassifier] = defaultDataCopy.splice(index, 1);
                        const newClassifier = replaceDefaultKeys(oldClassifier, defaultClassifier);
                        storage.post({
                            action: 'update',
                            actionParams: { internal: true },
                            id: row.id,
                            data: newClassifier,
                        });
                    }
                    else {
                        storage.post({
                            action: 'partial-update',
                            actionParams: { internal: true },
                            id: row.id,
                            data: { status: 'deprecated' },
                        });
                    }
                }
                for (const newClassifier of defaultDataCopy) {
                    // Classifiers have unique names, so we can search for them by name
                    const classifierValue = storage.list({
                        filter: [
                            {
                                column: 'name',
                                op: '=',
                                value: newClassifier.name,
                            },
                        ],
                    });
                    // Any non-default classifier will be converted to a default classifier
                    if (classifierValue.total === 0) {
                        storage.post({
                            action: 'create',
                            actionParams: { internal: true },
                            data: Object.assign(Object.assign({}, newClassifier), { default: newClassifier }),
                        });
                    }
                    else {
                        storage.post({
                            action: 'update',
                            actionParams: { internal: true },
                            id: classifierValue.rows[0].id,
                            data: Object.assign(Object.assign({}, newClassifier), { default: newClassifier }),
                        });
                    }
                }
            });
            if (classifier.publicData && storage.count({ filter: [{ op: '>=', updated: timestampBeforeSave }] }) > 0) {
                if (classifier.publicData === true) {
                    (0, saveClassifierPublicData_1.saveClassifierPublicData)(context, { entityName: entityName }, true);
                }
                else if (Array.isArray(classifier.publicData)) {
                    for (const publicDataParams of classifier.publicData) {
                        (0, saveClassifierPublicData_1.saveClassifierPublicData)(context, Object.assign(Object.assign({}, publicDataParams), { entityName: entityName }), true);
                    }
                }
                else if (typeof classifier.publicData === 'function') {
                    classifier.publicData(context.storage(entityName), context.publicData, true);
                }
            }
        });
    }
}
exports.saveClassifierDefaultData = saveClassifierDefaultData;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function replaceDefaultKeys(oldClassifier, defaultClassifier) {
    const newClassifier = Object.assign(Object.assign({}, oldClassifier), { default: defaultClassifier });
    for (const defaultKey of Object.keys(oldClassifier.default)) {
        if (JSON.stringify(oldClassifier[defaultKey]) === JSON.stringify(oldClassifier.default[defaultKey])) {
            newClassifier[defaultKey] = defaultClassifier[defaultKey];
        }
    }
    return newClassifier;
}
